import { Button, styled } from '@ltvco/refresh-lib/theme';
import { type ReactNode } from 'react';

import {
  PromoCompactBody,
  PromoCompactContent,
  PromoCompactCtaRow,
  PromoCompactIconWell,
  PromoCompactRoot,
  PromoCompactTitle,
  PromoDesktopBody,
  PromoDesktopCopy,
  PromoDesktopCtaRow,
  PromoDesktopIconFrame,
  PromoDesktopInner,
  PromoDesktopRoot,
  PromoDesktopTitle,
} from './PromoFeatureCard.styles';

export const PromoCtaButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(4),
  paddingLeft: theme.spacing(2.75),
  paddingRight: theme.spacing(2.75),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  fontSize: 15,
  fontWeight: 700,
  lineHeight: '26px',
  letterSpacing: '0.46px',
  textTransform: 'none',
  boxShadow: 'none',
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: theme.palette.primary.dark,
  },
}));

export type PromoFeatureCardProps = {
  isCompactLayout: boolean;
  illustration: ReactNode;
  title: string;
  body: string;
  cta: ReactNode;
  id?: string;
};

export function PromoFeatureCard({
  isCompactLayout,
  illustration,
  title,
  body,
  cta,
  id,
}: PromoFeatureCardProps) {
  if (isCompactLayout) {
    return (
      <PromoCompactRoot id={id}>
        <PromoCompactIconWell>{illustration}</PromoCompactIconWell>
        <PromoCompactContent>
          <PromoCompactTitle>{title}</PromoCompactTitle>
          <PromoCompactBody>{body}</PromoCompactBody>
          <PromoCompactCtaRow>{cta}</PromoCompactCtaRow>
        </PromoCompactContent>
      </PromoCompactRoot>
    );
  }

  return (
    <PromoDesktopRoot id={id}>
      <PromoDesktopInner>
        <PromoDesktopIconFrame>{illustration}</PromoDesktopIconFrame>
        <PromoDesktopCopy>
          <PromoDesktopTitle>{title}</PromoDesktopTitle>
          <PromoDesktopBody>{body}</PromoDesktopBody>
        </PromoDesktopCopy>
        <PromoDesktopCtaRow>{cta}</PromoDesktopCtaRow>
      </PromoDesktopInner>
    </PromoDesktopRoot>
  );
}
